import React, { useState, useEffect, useContext } from "react";
import { useNavigate, NavLink } from "react-router-dom";
// import { EyeIcon, FunnelIcon } from "@heroicons/react/20/solid";
import { useMutation, useQuery } from "@apollo/client";
// import { toast } from "react-toastify";
import toast from "react-hot-toast";

import Filter from "./components/PreAuthFilter";
import PreAuthResponseModal from "./components/PreAuthResponseModal";
import gqlPreAuth from "../../gql/preAuth";
import DownloadExcel from "../../components/DownloadExcel";
import { appContext } from "../../context/ContextProvider";
import Pagination from "../../components/Pagination";
import PollBtn from "../../components/PollBtn";

import "./styles/pre-auth.css";
import "../Beneficiary/styles/BeneficiaryList.css";
import ConformationModal from "../../components/ConformationModal";
import AppModal from "../../components/AppModal";
import PreAuthJsonViewModal from "./PreAuthJsonViewModal";
import { Badge, Chip, Tooltip } from "@mui/material";
import ConvertPreAuthToClaimModal from "./ConvertPreAuthToClaimModal";
import claims from "../../gql/claims";
import ReplayIcon from "@mui/icons-material/Replay";
import PreAuthPbmModal from "./PreAuthPbmModal";
import { useTranslation } from "react-i18next";
// import TableLoader from "../../common/TableLoader";
import TableSkeletonLoader from "../../common/TableLoading";
import AdavcnePreAuthJsonViewModal from "./AdavcnePreAuthJsonViewModal";
// import rawJson from "./adv.json";
import AppButton from "../../shared/AppButton";
import { FaFilter } from "react-icons/fa";
import AppTable from "../../shared/AppTable";

function AdvancePreAuth(props) {
  const { setShowLoader } = useContext(appContext);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentDate = new Date();
  const [loading, setLoading] = useState(false);
  const [openPbm, setOpenPbm] = useState(false);
  const [excelData, setExcelData] = useState([]);

  const [item, setItem] = useState({});
  const [showFilter, setShowFilter] = useState(() => {
    const saved = sessionStorage.getItem("advancePreAuthShowFilter");
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    sessionStorage.setItem(
      "advancePreAuthShowFilter",
      JSON.stringify(showFilter),
    );
  }, [showFilter]);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  // const [showPreAuthResponseModal, setShowPreAuthResponseModal] = useState(false); // OLD: unused
  const [showConvertToClaimModal, setShowConvertToClaimModal] = useState(false);

  const [open, setOpen] = useState(false);
  const [selectedItem, setSeelectedItem] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fromDate = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1,
  ).padStart(2, "0")}-01`;
  const toDate = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1,
  ).padStart(2, "0")}-${new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0,
  ).getDate()}`;

  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);

  // NEW: preAuthFilters with sessionStorage persistence
  const [preAuthFilters, setPreauthFilters] = useState(() => {
    const saved = sessionStorage.getItem("advancePreAuthFiltersSaved");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Failed to parse saved advancePreAuth filters", e);
      }
    }
    return {
      from_date: fromDate,
      to_date: toDate,
      fromDateOrdered: "",
      toDateOrdered: "",
      payer_name: "",
      type: "",
      patient_name: "",
      from_date_ordered: "",
      to_date_ordered: "",
      status: "",
      pre_auth_ref_no: "",
      request_bundle_id: "",
      payer_id: "",
      patient_id: "",
      limit: 10,
      page: 1,
    };
  });

  useEffect(() => {
    sessionStorage.setItem(
      "advancePreAuthFiltersSaved",
      JSON.stringify(preAuthFilters),
    );
  }, [preAuthFilters]);

  const {
    loading: dataLoading,
    error,
    data,
    refetch,
  } = useQuery(gqlPreAuth.GET_LIST_ADVANCE_PRE_AUTH_TRANSECTIONS, {
    variables: {
      input: {
        ...removeEmptyKeys(preAuthFilters),
      },
    },
    fetchPolicy: "cache-first", // NEW: added fetchPolicy
  });

  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message);
    }
  }, [error]);

  const {
    loading: excelDataLoading,
    error: excelDataError,
    data: excelDataResponse,
    refetch: refetchExcelDataResponse,
  } = useQuery(gqlPreAuth.GET_PREAUTH_EXCEL_DATA, {
    variables: {
      input: {
        from_date: fromDate,
        to_date: toDate,
      },
    },
    skip: true,
  });

  useEffect(() => {
    if (excelDataResponse) {
      setExcelData(
        JSON.parse(
          excelDataResponse?.listFullAdvancePreAuthTransactionsExcel?.data,
        ),
      );
    }
  }, [excelDataResponse]);

  // OLD: was using wrong key
  // useEffect(() => {
  //   if (excelDataResponse) {
  //     setExcelData(
  //       JSON.parse(excelDataResponse?.listPreAuthTransactionsExcel?.data),
  //     );
  //   }
  // }, [excelDataResponse]);

  const formatDateTime = (time) => {
    if (!time) return "";
    const sanitizedTime = time.replace(/\s\+\d{4}$/, "");
    const dateTime = new Date(sanitizedTime);
    if (isNaN(dateTime)) return "Invalid date";
    const dateOnly = dateTime.toLocaleDateString("en-GB");
    const timeOnly = dateTime.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${dateOnly} <br/> ${timeOnly}`;
  };

  // const onDataRowClicked = (event, item) => {
  //   navigate("/preauth/details", { state: { currentItem: item } });
  // };

  // const onDataRowClickedCommunication = (event, item) => {
  //   navigate("/preauth/details", {
  //     state: { currentItem: item, tabToActive: "communications" },
  //   });
  // };

  const onPageChange = async (currentPage) => {
    const payload = removeEmptyKeys(preAuthFilters);

    let filterInput = {
      ...payload,
      page: currentPage,
    };

    try {
      setLoading(true);
      await refetch({
        input: filterInput,
      });
    } finally {
      setLoading(false);
    }
    setPreauthFilters((prev) => ({
      ...prev,
      page: currentPage,
    }));
  };

  //cancel request
  const [
    cancelReq,
    { data: cancelData, loading: cancelLoading, error: cancelError },
  ] = useMutation(gqlPreAuth.CANCEL_REQUEST, {
    update(proxy, result) {
      onSuccessfulCancelRequestResponse(result.data);
    },
    onError(error) {
      onCancelResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulCancelRequestResponse = (data) => {
    if (data.cancelRequest) {
      toast.success("Successfully Cancelled!");
    } else {
    }
  };

  const onCancelResponseError = (error) => {
    toast.error(`${error.message}`);
  };

  const cancelClicked = async () => {
    cancelReq({
      variables: {
        input: {
          transaction_id: selectedItem?.transaction_id,
          request_name: "preAuth",
        },
      },
    }).then(async (res) => {
      const preAuthFilterDate = JSON.parse(
        localStorage.getItem("preAuthFilterDate"),
      );

      let filterInput = {
        ...preAuthFilterDate.filter((item) => item.key === "is_followup_req"),
        page: pageNo,
        limit: limit,
      };

      // Remove empty keys from claimsFilterDate
      const filteredPreAuthFilterDate = removeEmptyKeys(filterInput);

      try {
        setLoading(true);
        await refetch({
          input: filteredPreAuthFilterDate,
        });
      } finally {
        setLoading(false);
      }
    });
    setShowConfirmModal(false);
    setSeelectedItem(null);
  };
  //end Cancel Request

  // NEW: replaced getColor with getStatusStyles (same pattern as PreAuthList)
  const getStatusStyles = (status) => {
    const s = status?.toLowerCase();
    if (s === "approved" || s === "complete" || s === "success") {
      return { bg: "#dcfce7", text: "#15803d" }; // Green
    } else if (
      s === "rejected" ||
      s === "error" ||
      s === "cancel" ||
      s === "cancelled"
    ) {
      return { bg: "#fee2e2", text: "#b91c1c" }; // Red
    } else if (s === "pending" || s === "queued") {
      return { bg: "#fef9c3", text: "#854d0e" }; // Yellow
    } else {
      return { bg: "#f1f5f9", text: "#475569" }; // Gray
    }
  };

  const {
    loading: pollLoading,
    error: pollError,
    data: pollData,
    refetch: refetchPoll,
  } = useQuery(gqlPreAuth.PRE_AUTH_BULK_POLL_REQ, {
    skip: true, // Skip initial fetching
  });

  const {
    loading: communicationPollLoading,
    error: communicationPollError,
    data: communicationPollData,
    refetch: refetchCommunicationPoll,
  } = useQuery(gqlPreAuth.PRE_AUTH_COMMUNICATION_POLL, {
    skip: true, // Skip initial fetching
  });

  // NEW: excludes payer_id and patient_id (used as hidden FK fields, not filters)
  function removeEmptyKeys(obj) {
    const newObj = {};
    const excludedKeys = ["payer_id", "patient_id"];
    for (const key in obj) {
      if (obj[key] !== "" && !excludedKeys.includes(key)) {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  }

  // OLD: removeEmptyKeys without excludedKeys
  // function removeEmptyKeys(obj) {
  //   const newObj = {};
  //   for (const key in obj) {
  //     if (obj[key] !== "") {
  //       newObj[key] = obj[key];
  //     }
  //   }
  //   return newObj;
  // }

  const [
    checkReq,
    { data: checkData, loading: checkLoading, error: checkError },
  ] = useMutation(claims.CHECK_STATUS, {
    update(proxy, result) {
      onSuccessfulCheckRequestResponse(result.data);
    },
    onError(error) {
      onCancelResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulCheckRequestResponse = (data) => {
    if (!data.checkStatusRequest.nphies_err) {
      toast.success(
        data?.checkStatusRequest?.message || "Successfully Requested!",
      );
    } else if (data.checkStatusRequest.nphies_err) {
      // setErrorData(data.checkStatusRequest.nphies_err);
      // setShowErrorAlert(true);
    } else {
      toast.error(`Unknown Error`);
    }
  };

  // const onJsonView = (e, row) => {
  //   e.stopPropagation();
  //   setSeelectedItem({ ...row, ID: row.transaction_id });
  //   handleClickOpen();
  // };

  // NEW: columns array for AppTable (same pattern as PreAuthList)
  const columns = [
    {
      header: t("Status"),
      render: (row) => {
        const statusText = row?.status ?? "Approved";
        const styles = getStatusStyles(statusText);
        return (
          <Chip
            label={statusText}
            size="small"
            sx={{
              backgroundColor: styles.bg,
              color: styles.text,
              fontWeight: "700",
              fontSize: "10px",
              borderRadius: "6px",
              textTransform: "uppercase",
              height: 20,
            }}
          />
        );
      },
    },
    // {
    //   header: t("Outcome"),
    //   render: (row) => {
    //     const outcome = row?.outcome || "N/A";
    //     const styles = getStatusStyles(outcome);
    //     return (
    //       <Chip
    //         label={outcome}
    //         size="small"
    //         sx={{
    //           backgroundColor: styles.bg,
    //           color: styles.text,
    //           fontWeight: "700",
    //           fontSize: "10px",
    //           borderRadius: "6px",
    //           textTransform: "uppercase",
    //           height: 20,
    //         }}
    //       />
    //     );
    //   },
    // },
    { header: t("Transaction ID"), field: "transaction_id" },
    { header: t("Reason"), field: "reason" },
    {
      header: t("Created At"),
      render: (row) => (
        <span
          dangerouslySetInnerHTML={{
            __html: formatDateTime(row.created_at),
          }}
        />
      ),
    },
    {
      header: t("Reference No"),
      field: "pre_auth_ref_no",
    },
    {
      header: t("Type"),
      field: "type",
    },
    {
      header: t("Beneficiary"),
      render: (row) => (
        <span className="text-gray-700 w-[220px] block whitespace-pre-wrap">
          {row?.beneficiary || "---"}
        </span>
      ),
    },
    {
      header: t("Document Id"),
      field: "document_id",
    },
    {
      header: t("Diagnosis"),
      field: "diagnosis",
    },
    {
      header: t("Insurer"),
      render: (row) => (
        <span className="text-gray-700 w-[220px] block whitespace-pre-wrap">
          {row?.insurer || "---"}
        </span>
      ),
    },
  ];

  return (
    <>
      <div class="pre_auth_container !p-0 ">
        {/* NEW: Header section with AppButton + FaFilter (same as PreAuthList) */}
        <div className="flex justify-between flex-col lg:flex-row gap-2 mb-2">
          <div className="w-full">
            <span className="font-semibold text-black/70 text-lg ">
              {t("Advance Pre-Auth Transactions")}
              <span className=" text-lg ml-1">
                ({data?.listAdvancePreAuthTransactions?.total || 0}{" "}
                <span className="text-xs font-bold italic">{t("Entries")}</span>
                )
              </span>
            </span>
          </div>
        </div>

        {showFilter && (
          <div className="bg-white border rounded-lg p-2 mb-2">
            <Filter
              advancePreauth={true}
              refetch={refetch}
              refetchExcelDataResponse={refetchExcelDataResponse}
              setLoading={setLoading}
              preAuthFilters={preAuthFilters}
              setPreauthFilters={setPreauthFilters}
              fromDate={fromDate}
              toDate={toDate}
            />
          </div>
        )}

        {/* NEW: AppTable replaces manual <table> */}
        <div className="">
          <AppTable
          cellClassName="py-0"
            columns={columns}
            data={data?.listAdvancePreAuthTransactions?.data}
            loading={loading || dataLoading}
            onView={(row) => {
              navigate("/preauth/advance/preauth/details", {
                state: {
                  currentItem: row,
                },
              });
            }}
            onJsonView={(row) => {
              setSeelectedItem({ ...row, ID: row.transaction_id });
              handleClickOpen();
            }}
            LoaderComponent={
              <TableSkeletonLoader columnCount={11} rowCount={6} />
            }
          />
        </div>
        <div>
          <Pagination
            currentPage={preAuthFilters?.page}
            totalPages={data?.listAdvancePreAuthTransactions?.pages}
            onPageChange={onPageChange}
          />
        </div>
      </div>

      <PreAuthPbmModal setOpen={setOpenPbm} open={openPbm} />
      <ConformationModal
        open={showConfirmModal}
        setOpen={setShowConfirmModal}
        onDelete={() => cancelClicked(item)}
        text={"Cancel"}
      />
      {/* <PreAuthJsonViewModal
        setOpen={setOpen}
        open={open}
        handleClose={handleClose}
        selectedItem={selectedItem}
      /> */}
      <AdavcnePreAuthJsonViewModal
        setOpen={setOpen}
        open={open}
        handleClose={handleClose}
        selectedItem={selectedItem}
      />
      <ConvertPreAuthToClaimModal
        showConvertToClaimModal={showConvertToClaimModal}
        setShowConvertToClaimModal={setShowConvertToClaimModal}
        selectedItem={selectedItem}
      />
    </>
  );
}

export default AdvancePreAuth;
